import { useI18n } from "./i18n";
import copy from "./corporate-copy.json";
import "./corporate.css";

export default function Corporate() {
  const { language, content: { site } } = useI18n();
  const text = copy[language] || copy.en;
  const enquiry = `mailto:${site.email}?subject=${encodeURIComponent(text.subject)}&body=${encodeURIComponent(text.body)}`;
  return (
    <section className="corporate section-pad" id="corporate" aria-labelledby="corporate-title">
      <div className="section-shell">
        <header className="corporate__intro">
          <p className="eyebrow">{text.eyebrow}</p>
          <h2 id="corporate-title">{text.title}</h2>
          <p className="corporate__lead">{text.intro}</p>
          <a className="button" href="#corporate-enquiry">{text.cta} <span aria-hidden="true">↗</span></a>
        </header>
        <div className="corporate__idea">
          <h3>{text.ideaTitle}</h3><p>{text.idea}</p>
        </div>
        <h3 className="corporate__heading">{text.goalsTitle}</h3>
        <div className="corporate__goals">
          {text.goals.map(([title, body], index) => (
            <article key={title}><span className="corporate__number" aria-hidden="true">0{index + 1}</span><h4>{title}</h4><p>{body}</p></article>
          ))}
        </div>
        <aside className="corporate__focus"><h3>{text.focusTitle}</h3><p>{text.focus}</p></aside>
        <h3 className="corporate__heading">{text.transferTitle}</h3>
        <ol className="corporate__steps">
          {text.steps.map(([title, body]) => <li key={title}><h4>{title}</h4><p>{body}</p></li>)}
        </ol>
        <p className="corporate__audience">{text.audience}</p>
        <p className="corporate__safety">{text.safety}</p>
        <div className="corporate__enquiry" id="corporate-enquiry">
          <div><h3>{text.ctaTitle}</h3><p>{text.ctaText}</p></div>
          <div><a className="button button--dark" href={enquiry}>{text.cta} <span aria-hidden="true">↗</span></a><p className="corporate__mail-note">{text.mailNote}</p></div>
        </div>
      </div>
    </section>
  );
}
